import React from 'react';
import { AppBar, Toolbar, Typography, Box } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import './Navbar.css';
import { useDispatch, useSelector } from 'react-redux';
import { TokenState } from '../../../store/token/tokensReducer';
import { addToken } from '../../../store/token/actions';
import { toast } from 'react-toastify';

function Navbar() {

    const token = useSelector<TokenState, TokenState["tokens"]>(
        (state) => state.tokens
    );
    let history = useHistory();

    const dispatch = useDispatch();

    function goLogout() {
        dispatch(addToken(''));
        toast.info('Usuário deslogado', {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
            progress: undefined,
        });
        history.push('/login')
    }

    var navbarComponent;

    if (token != "") {
        navbarComponent = <AppBar position="static" className="MuiAppBar-colorPrimary " >
            <Toolbar variant="dense" className='tamanho MuiAppBar-colorPrimary teste' >
                <Box className='cursor navbar'>
                    <Typography variant="h5" color="inherit">
                    <img className="Logo" src="https://i.imgur.com/rXmjB99.png" alt="LogoTipo" width="48px" height="48px" />
                    </Typography>
                </Box>

                <Box display="flex"  >

                    <Link to="/home" className="text-decorator-none">
                        <Box mx={1} className='cursor navbar'>
                            <Typography variant="h6" color="inherit">
                                Home
                            </Typography>
                        </Box>
                    </Link>

                    <Link to="/posts" className="text-decorator-none">
                        <Box mx={1} className='cursor navbar'>
                            <Typography variant="h6" color="inherit">
                                Postagens
                            </Typography>
                        </Box>
                    </Link>

                    <Link to="/temas" className="text-decorator-none">
                        <Box mx={1} className='cursor navbar'>
                            <Typography variant="h6" color="inherit">
                                Temas
                            </Typography>
                        </Box>
                    </Link>

                    <Link to="/formularioTema" className="text-decorator-none">
                        <Box mx={1} className='cursor navbar'>
                            <Typography variant="h6" color="inherit">
                                Cadastrar tema
                            </Typography>
                        </Box>
                    </Link>


                    <Box mx={1} className='cursor navbar' onClick={goLogout}>
                        <Typography variant="h6" color="inherit" >
                            Sair
                        </Typography>
                    </Box>


                </Box>

            </Toolbar>
        </AppBar>
    }
    return (
        <>
            {navbarComponent}
        </>
    );
}

export default Navbar;